module.exports = __webpack_public_path__ + "files/aa5eb66d4d53729286402376b6c6d399.png";